import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";

/**
 * Floating "Essai gratuit" call-to-action pinned to the bottom of the mobile
 * viewport. Appears after the user has scrolled past the hero fold — so it
 * only shows up once the visitor is engaged, never in the way of the hero
 * CTAs. Mobile only (hidden on md+).
 */
export default function StickyMobileCTA({ threshold = 600 }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return (
    <div
      data-testid="sticky-mobile-cta"
      aria-hidden={!visible}
      className={`md:hidden fixed left-4 right-4 z-30 transition-all duration-300 will-change-transform ${
        visible
          ? "bottom-4 opacity-100 pointer-events-auto translate-y-0"
          : "bottom-0 opacity-0 pointer-events-none translate-y-6"
      }`}
    >
      <button
        type="button"
        data-testid="sticky-mobile-cta-btn"
        onClick={() => navigate("/register")}
        className="w-full h-14 rounded-sm bg-[#E05236] hover:bg-[#C94A31] text-white font-semibold text-sm tracking-wide shadow-lg shadow-[#E05236]/30 flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
      >
        {t("nav.signup")}
        <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
      </button>
    </div>
  );
}
